import {
  REVIEW_RATING,
  type ReviewRating,
} from "@-/dev.improve.haniverse.lib.cards.user-card.fsrs";

export const REVIEW_RATING_BY_DIGIT_KEY: Record<string, ReviewRating> = {
  "1": REVIEW_RATING.Again,
  "2": REVIEW_RATING.Hard,
  "3": REVIEW_RATING.Good,
  "4": REVIEW_RATING.Easy,
};
